import { render, staticRenderFns } from "./Classifiers.vue?vue&type=template&id=0528e4ce&scoped=true"
import script from "./Classifiers.vue?vue&type=script&lang=js"
export * from "./Classifiers.vue?vue&type=script&lang=js"
import style0 from "./Classifiers.vue?vue&type=style&index=0&id=0528e4ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0528e4ce",
  null
  
)

export default component.exports